import React from 'react'

const HomePageCarousel = () => {
  return (
    <div className='container-fluid navClearing'>
      <div className='mediaContainer'>
        <img
          className='d-block w-100 img-fluid'
          src='img/hero-1-bn-store-front.jpg'
          alt='Hero image'
        />
      </div>
    </div>
  )
}

export default HomePageCarousel
